import type { AuthResponse} from "../../shared/types";
import { USER_SLICE_LABEL } from "../storeLabels";
import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export const initialUserState: AuthResponse = {
  user: {
    id: "",
    email: "",
    fullName: "",
    role: "USER",
    brandId: "",
    isActive: false,
  },
  access_token: null,
};

export const UserSlice = createSlice({
  name: USER_SLICE_LABEL,
  initialState: initialUserState,
  reducers: {
    // ? Update user data
    updateUserData: (state, action) => {
      return {
        user: action.payload.user || state.user,
        access_token: action.payload.access_token || state.access_token,
      };
    },

    updateUserLogout: () => {
      return initialUserState;
    },
    updateUser(state, action: PayloadAction<AuthResponse["user"]>) {
      state.user = action.payload;
    },
    //
    // ? Update user data logoutß
    updateLogout: () => initialUserState,

    updateAccessToken: (state, action: PayloadAction<string | null>) => {
      state.access_token = action.payload;
    },
  },
});

export const {
  updateUserData,
  updateUserLogout,
  updateLogout,
  updateUser,
  updateAccessToken,
} = UserSlice.actions;
